// extracted by mini-css-extract-plugin
export default {"toggle":"MunicipalityToggle_toggle__9Y+6N","active":"MunicipalityToggle_active__OBtuK"};